import { useAuthHydration } from '@/hooks/use-auth-hydration';
import api from '@/services/api';
import { Charge } from '@/types/charge';
import { CHARGE_STATUS } from '@/types/charge-status';
import { useQuery } from '@tanstack/react-query';
import { chargeKeys } from './use-charges';

type PaginatedResponse<T> = {
  data: T[];
  meta: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    periodTotal?: number;
  };
};

export interface UseProviderChargesOptions {
  status?: CHARGE_STATUS;
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
}

export function useProviderCharges(options?: UseProviderChargesOptions) {
  const isHydrated = useAuthHydration();

  return useQuery({
    queryKey: [...chargeKeys.all, 'provider', 'list', options],
    queryFn: async () => {
      const params: Record<string, any> = {};
      if (options?.status) params.status = options.status;
      if (options?.startDate) params.startDate = options.startDate;
      if (options?.endDate) params.endDate = options.endDate;
      params.page = options?.page || 1;
      params.limit = options?.limit || 10;

      const response = await api.get<PaginatedResponse<Charge>>('/provider/charges', {
        params,
      });

      // Garantir que sempre retorna formato paginado
      const data = response.data;
      if (Array.isArray(data)) {
        // Se vier como array (formato antigo), converter para formato paginado
        const legacy: PaginatedResponse<Charge> = {
          data,
          meta: {
            page: 1,
            limit: data.length,
            total: data.length,
            totalPages: 1,
            hasNextPage: false,
            hasPreviousPage: false,
          },
        };
        return legacy;
      }

      return data;
    },
    enabled: isHydrated,
  });
}
